import type { RootState } from "../types/store";

export interface LoggedInUsersDetailsBasic {
  email?: string;
  username?: string;
}

export function selectLoggedInUsersDetails(
  state: RootState
): LoggedInUsersDetailsBasic | undefined {
  const raw = selectLoggedInUsersDetailsRecord(state);
  if (!raw) return undefined;
  return raw as LoggedInUsersDetailsBasic;
}

export function selectLoggedInUserEmail(state: RootState): string | undefined {
  const d = selectLoggedInUsersDetails(state);
  const v = d?.email;
  if (v === undefined || v === null) return undefined;
  const s = String(v).trim();
  return s !== "" ? s : undefined;
}

export function selectLoggedInUserEmailOrUsername(state: RootState): string | undefined {
  const d = selectLoggedInUsersDetails(state);
  const v = d?.email ?? d?.username;
  if (v === undefined || v === null) return undefined;
  const s = String(v).trim();
  return s !== "" ? s : undefined;
}

export function selectLoggedInClientProfileId(state: RootState): string | null {
  const raw = selectLoggedInUsersDetailsRecord(state);
  if (!raw) return null;
  const d = raw as {
    business_link?: { client_id?: string | number };
    client_id?: string | number;
  };
  const id = d.business_link?.client_id ?? d.client_id;
  if (id === undefined || id === null) return null;
  const s = String(id).trim();
  return s !== "" ? s : null;
}

export function selectLoggedInUsersDetailsRecord(
  state: RootState
): Record<string, unknown> | undefined {
  const fromFeatureAccess = state.featureAccess?.userDetails;
  if (fromFeatureAccess && typeof fromFeatureAccess === "object") {
    return fromFeatureAccess as Record<string, unknown>;
  }
  const fromLogin = state.loginDetails?.logedInUsersDetails;
  if (fromLogin && typeof fromLogin === "object") {
    return fromLogin as Record<string, unknown>;
  }
  return undefined;
}

export function selectDeviceToken(state: RootState): string | null {
  const token = state.auth?.deviceToken ?? state.loginDetails?.deviceToken;
  if (token === undefined || token === null) return null;
  const s = String(token).trim();
  return s !== "" ? s : null;
}

export function selectSessionId(state: RootState): string | null {
  const id = state.auth?.sessionId ?? state.loginDetails?.sessionId;
  if (id === undefined || id === null) return null;
  const s = String(id).trim();
  return s !== "" ? s : null;
}

export function selectLoggedInUsername(state: RootState): string | null {
  const fromDetails = selectLoggedInUsersDetailsRecord(state);
  const candidate = fromDetails?.username ?? fromDetails?.email ?? state.auth?.user?.username;
  if (candidate === undefined || candidate === null) return null;
  const s = String(candidate).trim();
  return s !== "" ? s : null;
}
